import { useState } from "react";
import { useData, useDispatch } from "./DataContext.js";

import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

const startCode = "";

export default function LoadSessionModal (props)
{
    const gData = useData();
    const gDispatch = useDispatch();

    const [code, setCode] = useState(startCode);

    const codeValue = code.length < 3 ? code : code.substring(0, 3) + " " + code.substring(3, code.length);

    function hide ()
    {
	setCode("");
	props.hide();
    }

    function handleCodeChange (e)
    {
	let nextCodeValue = e.target.value;
	if (nextCodeValue + " " === codeValue) nextCodeValue = nextCodeValue.substring(0, nextCodeValue.length-1);

	let nextCode = nextCodeValue.replace(/[^a-zA-Z0-9]+/g, "").toUpperCase();
	if (nextCode.length > 6) nextCode = nextCode.substring(0, 6);
	setCode(nextCode);
    }

    function loadSession ()
    {
	setCode("");
	gDispatch({ type: "loadSession", code, password: gData.session.password });
    }

    
    return (
	<Modal
	    size="md"
	    show={props.show}
	    onHide={hide}
	    centered
	>
	    <Modal.Header className="bg-light" closeButton>
		<Modal.Title>Charger une session existante</Modal.Title>
	    </Modal.Header>
	    <Modal.Body>
		<Form className="d-flex flex-column gap-3 align-items-end">
		    <Form.Group className="w-100">
			<Form.Label>Code d'accès à la session (6 caractères)</Form.Label>
			<Form.Control size="lg" type="text" autoFocus placeholder="XXX XXX" className="text-center" value={codeValue} onChange={handleCodeChange} aria-label="Code d'accès"/>
		    </Form.Group>

		    <Button variant="primary" type="submit" disabled={code.length !== 6} onClick={(e) => { e.preventDefault(); loadSession(); }}>Valider</Button>
		</Form>
	    </Modal.Body>
	</Modal>
    );
}

